import React from 'react';
import { createRoot } from 'react-dom/client';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.esm.min';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'antd/dist/reset.css';
import App from './app/App';
import "./App.css";

const root = createRoot(document.getElementById('root'));

root.render(<App />);